// Resolves which farmhouse unit a booking belongs to, across the three data
// shapes we've accumulated: new bookings carry `farmhouse` ('gold'/'silver'),
// admin slip entries carry `unit` ('Gold'/'Silver'), and legacy bookings carry
// neither — those predate the Silver unit, so they default to Gold.
export function getUnit(booking) {
  if (booking.farmhouse) return booking.farmhouse;
  if (booking.unit) return booking.unit.toLowerCase();
  return 'gold';
}

// True when the app should skip straight to the Admin Dashboard instead of
// the landing page / booking flow — either the dedicated admin subdomain
// (once its DNS is connected) or the `#admin` hash, which works immediately
// without waiting on DNS and is handy for testing. Same Firebase
// Authentication email/password gate either way — this only changes which
// screen you land on, not who's allowed in.
export function isAdminEntry() {
  return window.location.hostname === 'admin.riazfarmhouse.com' || window.location.hash === '#admin';
}

const MONTHS_PK = ['January','February','March','April','May','June','July','August','September','October','November','December'];

// Day-month-year, e.g. "7 July 2026" — the format Pakistani staff/customers
// read dates in, used everywhere a date is displayed (never for the
// underlying <input type="date"> value itself, which must stay ISO
// yyyy-mm-dd). Plain "yyyy-mm-dd" strings (checkInDate) are parsed by hand
// instead of via `new Date(...)`, since that constructor treats them as UTC
// midnight and would silently shift a day off in some timezones once
// re-rendered via toLocaleDateString.
export function formatDatePK(dateStr) {
  if (!dateStr) return '—';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateStr);
  if (m) {
    const [, y, mo, da] = m;
    return `${parseInt(da, 10)} ${MONTHS_PK[parseInt(mo, 10) - 1]} ${y}`;
  }
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Karachi' });
}

// Same date format plus a 12-hour Pakistan-time clock reading, for full
// timestamps (createdAt, blockedAt, askedAt, ...) rather than plain dates.
export function formatDateTimePK(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  const timePart = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Asia/Karachi' });
  return `${formatDatePK(iso)}, ${timePart}`;
}